const CakeEditJSONApi = async (
  Method,
  SpecificAdminCake,
  setAdminCCResponse,
  SuccessText
) => {
  let FetchApiBody = SpecificAdminCake
    ? JSON.parse(JSON.stringify(SpecificAdminCake))
    : {};

  if (!["PUT", "DELETE", "POST"].includes(Method)) {
    alert("Method not working properly");
    return null;
  }
  return await fetch(
    `https://api.jsonbin.io/v3/b/${process.env.REACT_APP_CAKES_BIN_ID}`,
    {
      method: Method,
      headers: {
        "Content-Type": "application/json",
        "X-Master-Key":
          "$2a$10$jNtgKWEqFsk8F.nyMllFdeKYpt6pE0xv5653.ySygQXe7WQ4ZiFpK",
      },
      body: JSON.stringify(FetchApiBody),
    }
  ).then((response) => {
    if (response.ok) {
      setAdminCCResponse([
        "flex",
        "flex",
        "Cakes Updating...",
        "light-success",
      ]);
      setTimeout(() => {
        setAdminCCResponse(["flex", "none", SuccessText, "light-success"]);
      }, 200);
    } else {
      setAdminCCResponse([
        "flex",
        "none",
        "Failed Cakes Updating Failed",
        "danger",
      ]);
      setTimeout(() => {
        setAdminCCResponse(["flex", "none", "Failed! Not Updated", "danger"]);
      }, 200);
    }
    setTimeout(() => {
      setAdminCCResponse([
        "none",
        "none",
        "Cakes Updating...",
        "light-success",
      ]);
    }, 1000);
    return response.status;
  });
};
export default CakeEditJSONApi;
// const EditfetchCakes = async (AdminCakes, setAdminCCResponse) => {
//   var ClonedCAC = JSON.parse(JSON.stringify(AdminCakes));

//   // eslint-disable-next-line
//   ClonedCAC.map((CAC, i) => {
//     CAC.id = i;
//   });

//   fetch("http://localhost:5000/cakes", {
//     method: "PUT",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(ClonedCAC),
//   })
//     .then((response) => {
//       setAdminCCResponse &&
//         setAdminCCResponse(["block", "Cakes Updating...", "block"]);
//       return response.json();
//     })
//     .then((data) => {
//       if (typeof data === "object") {
//         setTimeout(() => {
//           setAdminCCResponse &&
//             setAdminCCResponse(["block", "Success!", "none"]);
//           setTimeout(() => {
//             setAdminCCResponse &&
//               setAdminCCResponse(["none", "Success!", "none"]);
//             window.location.reload();
//           }, 1000);
//         }, 1000);
//       } else {
//         setAdminCCResponse &&
//           setAdminCCResponse(["block", "Error Updating!", "block"]);
//         setTimeout(() => {
//           window.location.reload();
//         }, 2000);
//       }
//     });
// };

// export default EditfetchCakes;
